import { render, staticRenderFns } from "./ProductInfoNew.vue?vue&type=template&id=7b30cc7f&scoped=true&"
import script from "./ProductInfoNew.vue?vue&type=script&lang=js&"
export * from "./ProductInfoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b30cc7f",
  null
  
)

export default component.exports